import { trpc } from "@/Utils/trpc";
import {
  type TimeFilter,
  defaultTimeFilter,
} from "@/components/v2/DatePicker/constants";
import { useTrans } from "@/translations";

import { useMemo } from "react";

type Props = {
  timeFilter?: TimeFilter;
};

export const PortfolioHeader: React.FC<Props> = ({ timeFilter }) => {
  const { t } = useTrans();

  const { data: aggregatesData, isLoading } =
    trpc.dwh.terminals.getAggregates.useQuery(timeFilter || defaultTimeFilter, {
      queryKeyHashFn: () =>
        [
          "terminalAggregates",
          timeFilter?.startTimeISO,
          timeFilter?.endTimeISO,
        ].toString(),
      enabled: !!timeFilter,
    });
  const nrBuildings = useMemo(
    () =>
      aggregatesData?.terminalAggregates.totalNonDeletedTerminalsAcrossClient,
    [aggregatesData],
  );

  const nrTenants = useMemo(
    () => aggregatesData?.terminalAggregates.totalCustomersAcrossClient,
    [aggregatesData],
  );

  return (
    <div>
      <div className="align-center ml-[20px] flex">
        <div className="flex flex-col justify-between">
          <div className="font-signifier height-[42px] text-[40px] leading-[42px]">
            {t("portfolioPage:title")}
          </div>
          {!isLoading && !!aggregatesData && (
            <div>
              <div className="mt-[4px] flex items-center text-[13.5px]">
                <div className="font-dm-sans text-grey6">
                  {t("portfolioPage:nrBuildings", { nrBuildings })}
                </div>
                <div className="font-dm-sans text-grey4 ml-[12px]">·</div>
                <div className="font-dm-sans text-grey6 ml-2">
                  {t("portfolioPage:nrTenants", { nrTenants })}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
